import { BankListPage } from '@/features/bank/pages/BankListPage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/bank/')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["bank.view"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: BankListPage,
})
